import moment from 'moment';

export const minimumMoment = moment.utc([1900, 0, 1]); // 1900-1-1
export const minimumDate = minimumMoment.toDate();
/**
 * Validator function
 *
 * @callback validatorFunction
 * @param {any} date The date to check
 * @returns {boolean} IsValid
 */

/**
 *  @function validateMinimum
 *  @type {validatorFunction}
 */
export const validateMinimumDate = date => {
  if (!date) return true; // Required should be checked separately
  if (!moment.isMoment(date)) return false;
  return moment(date).isSameOrAfter(minimumMoment, 'day');
};

export const validateRequired = value => typeof value !== 'undefined' && value !== null;

// Use as isOutsideRange attribute in react datepicker control
export const isBeforeMinimum = date => {
  if (!moment.isMoment(date)) return false;
  return moment(date).isBefore(minimumMoment, 'day');
};

export const isBeforeToday = date => {
  if (!moment.isMoment(date)) return false;
  return moment(date).isBefore(moment.utc(), 'day');
};
export const isBeforeTomorrow = date => {
  if (!moment.isMoment(date)) return false;
  return moment(date).isBefore(moment.utc().add(1, 'days'), 'day');
};
export const isBeforeLastYear = date => {
  if (!moment.isMoment(date)) return false;
  return moment(date).isBefore(moment.utc().add(-1, 'year'), 'day');
};
export const isBefore = (date, endDate) => {
  if (!moment.isMoment(date)) return false;
  if (!moment.isMoment(endDate)) return false;
  return moment(date).isBefore(endDate, 'day');
};
export const validateDateRange = (
  startDate,
  endDate,
  startRequired = false,
  endRequired = false,
) => {
  if (startRequired && (!startDate || !moment.isMoment(startDate))) return false;
  if (endRequired && (!endDate || !moment.isMoment(endDate))) return false;
  if (isBeforeMinimum(startDate)) return false;
  if (isBeforeMinimum(endDate)) return false;
  if (startDate && endDate && moment(endDate).isBefore(moment(startDate), 'd')) return false;
  return true;
};
export const isInRange = (date, rangeStart, rangeEnd, required = false) => {
  if (!date || !moment.isMoment(date)) return !required;
  if (isBefore(date, rangeStart)) return false;
  if (isBefore(rangeEnd, date)) return false;
  return true;
};
export const isOutRange = (date, rangeStart, rangeEnd, required = false) =>
  !isInRange(date, rangeStart, rangeEnd, required);

export const validateEndDate = (endDate, startDate = null, required = false) =>
  validateDateRange(startDate, endDate, false, required);

// /**
//  * Validate multiple validator functions
//  * @function validateAll
//  * @param  {...validatorFunction} functions
//  * @returns {boolean} IsValid
//  */
// export const validateAll = (...functions) => date => !functions.some(x => !x(date));

export const falseFunc = () => false;

export const isNullOrUndefined = value => {
  if (typeof value === 'undefined') return true;
  if (value === null) return true;
  return false;
};
export const isValidNumber = value => {
  if (isNullOrUndefined(value)) return false;
  return !Number.isNaN(value);
};

export const isNumberInRange = (value, min, max) => {
  if (!isValidNumber(value)) return false;
  return min <= value && value <= max;
};
const emptyHtml =
  '<html>\n<head>\n\t<title></title>\n</head>\n<body style="height: auto; min-height: auto;"></body>\n</html>\n';
export const isEmptyHtmlField = value => {
  if (!value) return true;
  if (value === emptyHtml) return true;
  return false;
};
